import { createFileRoute, useRouter, useSearch } from "@tanstack/react-router"
import { useEffect } from "react"

type MagicLinkSearch = {
  type?: "login" | "onboarding"
  token?: string
}

export const Route = createFileRoute("/magic-link/$")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): MagicLinkSearch => {
    return {
      type: search.type as "login" | "onboarding" | undefined,
      token: search.token as string | undefined,
    }
  },
})

function RouteComponent() {
  const router = useRouter()
  const search = useSearch({ from: "/magic-link/$" })

  useEffect(() => {
    const { type, token } = search

    if (type === "login" && token) {
      router.navigate({ to: `/login/${token}`, replace: true })
    } else if (type === "onboarding" && token) {
      router.navigate({ to: `/onboarding/${token}`, replace: true })
    } else {
      router.navigate({ to: "/login", replace: true })
    }
  }, [router, search])

  return null
}
